import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ProductMatchResult = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Safely extract info from state
  const { product, matches = [], lab = null } = location.state || {};

  if (!product || !matches.length) {
    return (
      <div style={{padding: 32}}>
        <h2>No product or matches found.</h2>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 850, margin: '2rem auto', padding: '2rem 1rem' }}>
      {/* Product Info Section */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 32 }}>
        <div style={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          background: product.shadeHex,
          marginRight: 22,
          border: '2px solid #bbb'
        }} />
        <div>
          <div style={{fontWeight: 700, fontSize: 20}}>
            {product.brand} — {product.product}
          </div>
          <div>Shade: <b>{product.shade}</b></div>
          <div>HEX: <span style={{fontFamily: 'monospace'}}>{product.shadeHex}</span></div>
          {lab && (
            <div>LAB: <span style={{fontFamily: 'monospace'}}>{lab.map(x => x.toFixed(2)).join(', ')}</span></div>
          )}
        </div>
      </div>

      <h3>Closest Matches</h3>
      <div style={{overflowX: "auto"}}>
        <table className="table table-bordered" style={{minWidth: 520}}>
          <thead>
            <tr>
              <th>Brand</th>
              <th>Product</th>
              <th>Shade</th>
              <th>Percent Match</th>
            </tr>
          </thead>
          <tbody>
            {matches.map((m, idx) => (
              <tr key={idx}>
                <td>{m.Brand}</td>
                <td>{m.Product}</td>
                <td>{m.Shade}</td>
                <td>{m['Percent Match']}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button style={{background:"#7D7ABC"}} className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
        Start New Search
      </button>
    </div>
  );
};

export default ProductMatchResult;
